export default "__VITE_ASSET__DbwrCK_q__"